import React, { Component } from "react";
import { Tabs } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import { Col } from "reactstrap";
import { Card } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { Button } from "react-bootstrap";
import SimpleReactValidator from 'simple-react-validator';
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import { logincheck } from '../Userlogin/Userlogin'
import dateFormat from 'dateformat';
import firebase from "firebase/app";
import "firebase/storage";

class EditCustomerDetails extends Component {
    constructor(props) {  
        super(props);
        this.state = {
            customerId: this.props.location.data ? this.props.location.data : this.props.location.state.data ? this.props.location.state.data : 0,
            "apartmentName": "", "apartmentPhoneNumber": "", "associationName": "", "apartmentType": "", "roadSize": "", "doorNumber": "", "streetName": "",
            "distanceBetweenGateAndSump": "", "area": "", "city": "Chennai", "landmark": "", "pincode": "",
            "numberOfTowers": "", "numberOfHomes": "", "tankCapacity": "", "dailyNeed": "", "totalDissolvedSolids": "",
            "pocName1": "", "pocContactNumber1": "", "pocName2": "", "pocContactNumber2": "", vipCustomer: "",apartmentcontact1Required:false,apartmentcontact2Required: false,
            oldDoorNumber: "", oldStreetName: "", oldArea: "", oldCity: "", oldLat: "", oldLng: "", apartmentId: "","apartmentPhoneNumberRequired": false,contact1: "", contact2: "",
			"userFirstName": "", "userLastName": "", "pocUserId": "", profileImg: '',contactdocumenturl: '', editcontact: '',editprofile: ''
        };
        this.nextPath = this.nextPath.bind(this);
        this.handleFormFields = this.handleFormFields.bind(this);
        this.validForm = this.validForm.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.documenturlChange= this.documenturlChange.bind(this);
        this.validator = new SimpleReactValidator({ messages: { currency: "Must be a valid number" }, autoForceUpdate: this, className: 'text-danger' });
    }
	
	 


    nextPath(path, value) {
        this.props.history.push({ pathname: path, data: value });
    }
	handleChange = event => {
		this.setState({editprofile: event.target.files[0]}, function () { });
 
	} 
	documenturlChange = event => {
		this.setState({editcontact: event.target.files[0]}, function () { });
	}

    componentDidMount() {
		logincheck(this.props.userId, this.props.mobiledevice).then(({ data: data }) => {
			console.log(data.status_check)
			if(data.status_check === 0) {
				this.props.history.push({ pathname: `/Logout`, state: { userId : this.props.userId , logintoken: 2 } });
			}
		})
        const url = process.env.REACT_APP_NODE_ENV + "/api/apart-customer/getACbyId/" + this.state.customerId
        fetch(url,{
            method:'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              }
        }).then(
            response => { return response.json(); }
        ).then(data => {
			console.log(data)
            this.setState({
				userFirstName: data[0].user.userFirstName, userLastName: data[0].user.userLastName, 
                apartmentId: data[0].apartmentId,
                oldDoorNumber: data[0].doorNumber, oldStreetName: data[0].streetName,
                oldArea: data[0].area, oldCity: data[0].city, 
                apartmentName: data[0].apartmentName, associationName: data[0].associationName,
                doorNumber: data[0].doorNumber, vipCustomer: data[0].vipCustomer,
                streetName: data[0].streetName, area: data[0].area, city: data[0].city,
                landmark: data[0].landmark, pincode: data[0].pincode, apartmentType: data[0].apartmentType,
                roadSize: data[0].roadSize, apartmentPhoneNumber: data[0].apartmentPhoneNumber,
                distanceBetweenGateAndSump: data[0].distanceBetweenGateAndSump,
                numberOfTowers: data[0].numberOfTowers, numberOfHomes: data[0].numberOfHomes,
                tankCapacity: data[0].tankCapacity, dailyNeed: data[0].dailyNeed, totalDissolvedSolids: data[0].totalDissolvedSolids,
                pocName1: data[0].pocName1, pocContactNumber1: data[0].pocContactNumber1, contact1 : data[0].pocContactNumber1,
                pocName2: data[0].pocName2, pocContactNumber2: data[0].pocContactNumber2, contact2: data[0].pocContactNumber2,  pocUserId:  data[0].pocUserId,
				contactdocumenturl : data[0].contractdocumenturl,  profileimageurl :   data[0].profileimageurl
            }, () => this.fetchExistingAddress())
        }).catch(error => console.log(error))
    }

    fetchExistingAddress = () => {
        let address = this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city
        console.log(this.state.apartmentId, address)
        let postAddressData = {
            associateId: this.state.apartmentId,
            fullAddress: address
        }
        fetch(process.env.REACT_APP_NODE_ENV + '/api/address/getAddressbyCustomerIdandFullAddress', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              },
            body: JSON.stringify(postAddressData)
        }).then(
            response => { return response.json(); }
        ).then(data => { console.log(data); this.setState({ oldLat: data.geolocationLat, oldLng: data.geolocationLng }) })
            .catch(error => console.log(error))
    }

    save = () => {
        if ((this.validator.allValid()) && this.state.apartmentcontact2Required  != 1  && this.state.apartmentcontact1Required  != 1  &&  (this.state.apartmentPhoneNumberRequired != 1 || this.state.apartmentPhoneNumberRequired === "" ) ) {
			console.log(this.state.editprofile, this.state.editcontact)
			var assing_profile=""
			if(this.state.editprofile != "" && this.state.editcontact != "") 
			{
				assing_profile="3"
			}
			else if(this.state.editprofile != "") {
				assing_profile="1"
			}
			else if(this.state.editcontact != "") {
				assing_profile="2"
			}
			if(assing_profile === "3")
			{
				var Image_name =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.editprofile.name;
				const uploadTask = firebase.storage().ref(`media/${Image_name}`).put(this.state.editprofile).then(snapshot => {
					var Image_name1 =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.editcontact.name;
					const uploadTask = firebase.storage().ref(`media/${Image_name1}`).put(this.state.editcontact).then(snapshots => {
							const postCustData = {
						"userFirstName": this.state.userFirstName,"userLastName": this.state.userLastName,
						"apartmentName": this.state.apartmentName, "associationName": this.state.associationName,
						"customerUserId": this.state.pocUserId,"pocUserId": this.state.pocUserId,
						"doorNumber": this.state.doorNumber, "vipCustomer": this.state.vipCustomer,
						"streetName": this.state.streetName, "area": this.state.area, "city": this.state.city,
						"state": this.state.state, "landmark": this.state.landmark,
						"pincode": this.state.pincode, apartmentType: this.state.apartmentType, roadSize: this.state.roadSize,
						"apartmentPhoneNumber": this.state.apartmentPhoneNumber,
						"distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
						"numberOfTowers": this.state.numberOfTowers, "numberOfHomes": this.state.numberOfHomes,
						"tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed, "totalDissolvedSolids": this.state.totalDissolvedSolids,
						"pocName1": this.state.pocName1, "pocContactNumber1": this.state.pocContactNumber1,
						"pocName2": this.state.pocName2, "pocContactNumber2": this.state.pocContactNumber2, "profileimageurl" :  snapshot.metadata.downloadURLs[0]  ,"contractdocumenturl": snapshots.metadata.downloadURLs[0],
						id: this.state.customerId
						};

						fetch(process.env.REACT_APP_NODE_ENV + '/api/apart-customer/updateCustomer', {
						method: 'PUT',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
						  },
						body: JSON.stringify(postCustData)
						}).then(response => response.json())
						.then(data => {
							// if (this.state.oldDoorNumber !== this.state.doorNumber ||
								// this.state.oldStreetName !== this.state.streetName ||
								// this.state.oldArea !== this.state.area ||
								// this.state.oldCity !== this.state.city) {
								// this.createNewDriveryAddress(data[0].apartmentId);
							// } else {
								this.nextPath("/aprt-customer/customer-details", this.state.customerId)
								toast.success("Profile updated successfully!!!", {
									position: toast.POSITION.TOP_CENTER,

								});
							// }
						})
						.catch((err) => console.log(err))
							
					})
				})
			}
			else if(assing_profile === "1") {
				var Image_name =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.editprofile.name;
				const uploadTask = firebase.storage().ref(`media/${Image_name}`).put(this.state.editprofile).then(snapshot => {
						const postCustData = {
						"userFirstName": this.state.userFirstName,"userLastName": this.state.userLastName,
						"apartmentName": this.state.apartmentName, "associationName": this.state.associationName,
						"customerUserId": this.state.pocUserId,"pocUserId": this.state.pocUserId,
						"doorNumber": this.state.doorNumber, "vipCustomer": this.state.vipCustomer,
						"streetName": this.state.streetName, "area": this.state.area, "city": this.state.city,
						"state": this.state.state, "landmark": this.state.landmark,
						"pincode": this.state.pincode, apartmentType: this.state.apartmentType, roadSize: this.state.roadSize,
						"apartmentPhoneNumber": this.state.apartmentPhoneNumber,
						"distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
						"numberOfTowers": this.state.numberOfTowers, "numberOfHomes": this.state.numberOfHomes,
						"tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed, "totalDissolvedSolids": this.state.totalDissolvedSolids,
						"pocName1": this.state.pocName1, "pocContactNumber1": this.state.pocContactNumber1,
						"pocName2": this.state.pocName2, "pocContactNumber2": this.state.pocContactNumber2, "profileimageurl" :  snapshot.metadata.downloadURLs[0],
						id: this.state.customerId
						};

						fetch(process.env.REACT_APP_NODE_ENV + '/api/apart-customer/updateCustomer', {
						method: 'PUT',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
						  },
						body: JSON.stringify(postCustData)
						}).then(response => response.json())
						.then(data => {
							// if (this.state.oldDoorNumber !== this.state.doorNumber ||
								// this.state.oldStreetName !== this.state.streetName ||
								// this.state.oldArea !== this.state.area ||
								// this.state.oldCity !== this.state.city) {
								// this.createNewDriveryAddress(data[0].apartmentId);
							// } else {
								this.nextPath("/aprt-customer/customer-details", this.state.customerId)
								toast.success("Profile updated successfully!!!", {
									position: toast.POSITION.TOP_CENTER,

								});
							// }
						})
						.catch((err) => console.log(err))
							
						})
				
				
			}
			else if(assing_profile === "2") {
				var Image_name1 =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.editcontact.name;
				const uploadTask = firebase.storage().ref(`media/${Image_name1}`).put(this.state.editcontact).then(snapshots => {
						const postCustData = {
						"userFirstName": this.state.userFirstName,"userLastName": this.state.userLastName,
						"apartmentName": this.state.apartmentName, "associationName": this.state.associationName,
						"customerUserId": this.state.pocUserId,"pocUserId": this.state.pocUserId,
						"doorNumber": this.state.doorNumber, "vipCustomer": this.state.vipCustomer,
						"streetName": this.state.streetName, "area": this.state.area, "city": this.state.city,
						"state": this.state.state, "landmark": this.state.landmark,
						"pincode": this.state.pincode, apartmentType: this.state.apartmentType, roadSize: this.state.roadSize,
						"apartmentPhoneNumber": this.state.apartmentPhoneNumber,
						"distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
						"numberOfTowers": this.state.numberOfTowers, "numberOfHomes": this.state.numberOfHomes,
						"tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed, "totalDissolvedSolids": this.state.totalDissolvedSolids,
						"pocName1": this.state.pocName1, "pocContactNumber1": this.state.pocContactNumber1,
						"pocName2": this.state.pocName2, "pocContactNumber2": this.state.pocContactNumber2,"contractdocumenturl": snapshots.metadata.downloadURLs[0],
						id: this.state.customerId
						};

						fetch(process.env.REACT_APP_NODE_ENV + '/api/apart-customer/updateCustomer', {
						method: 'PUT',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
						  },
						body: JSON.stringify(postCustData)
						}).then(response => response.json())
						.then(data => {
							// if (this.state.oldDoorNumber !== this.state.doorNumber ||
								// this.state.oldStreetName !== this.state.streetName ||
								// this.state.oldArea !== this.state.area ||
								// this.state.oldCity !== this.state.city) {
								// this.createNewDriveryAddress(data[0].apartmentId);
							// } else {
								this.nextPath("/aprt-customer/customer-details", this.state.customerId)
								toast.success("Profile updated successfully!!!", {
									position: toast.POSITION.TOP_CENTER,

								});
							// }
						})
						.catch((err) => console.log(err))
							
						})
				
			}
			else {
			
            const postCustData = {
				"userFirstName": this.state.userFirstName,"userLastName": this.state.userLastName,
                "apartmentName": this.state.apartmentName, "associationName": this.state.associationName,
                "customerUserId": this.state.pocUserId,"pocUserId": this.state.pocUserId,
                "doorNumber": this.state.doorNumber, "vipCustomer": this.state.vipCustomer,
                "streetName": this.state.streetName, "area": this.state.area, "city": this.state.city,
                "state": this.state.state, "landmark": this.state.landmark,
                "pincode": this.state.pincode, apartmentType: this.state.apartmentType, roadSize: this.state.roadSize,
                "apartmentPhoneNumber": this.state.apartmentPhoneNumber,
                "distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
                "numberOfTowers": this.state.numberOfTowers, "numberOfHomes": this.state.numberOfHomes,
                "tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed, "totalDissolvedSolids": this.state.totalDissolvedSolids,
                "pocName1": this.state.pocName1, "pocContactNumber1": this.state.pocContactNumber1,
                "pocName2": this.state.pocName2, "pocContactNumber2": this.state.pocContactNumber2,
                id: this.state.customerId
            };
			
            fetch(process.env.REACT_APP_NODE_ENV + '/api/apart-customer/updateCustomer', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
                  },
                body: JSON.stringify(postCustData)
            }).then(response => response.json())
                .then(data => {
                    // if (this.state.oldDoorNumber !== this.state.doorNumber ||
                        // this.state.oldStreetName !== this.state.streetName ||
                        // this.state.oldArea !== this.state.area ||
                        // this.state.oldCity !== this.state.city) {
                        // this.createNewDriveryAddress(data[0].apartmentId);
                    // } else {
                        this.nextPath("/aprt-customer/customer-details", this.state.customerId)
						toast.success("Profile updated successfully!!!", {
							position: toast.POSITION.TOP_CENTER,

						});
                    // }
                })
                .catch((err) => console.log(err))
			}
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    createNewDriveryAddress = (apartmentId) => {
        fetch(
            "https://maps.googleapis.com/maps/api/geocode/json?address=" +
            this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city +
            "&key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN",
        )
            .then(data => data.json())
            .then(resp => {
                const { lat, lng } = resp.results[0].geometry.location;
                console.log(lat, lng, this.state.oldLat, this.state.oldLng)
                if (lat !== this.state.oldLat || lng !== this.state.oldLng) { this.createAddress(apartmentId, lat, lng) }
                else { this.nextPath("/aprt-customer/customer-details", this.state.customerId) }
                this.setState({ lat: lat, lng: lng })
            })
            .catch(err => console.log(err));
    }

    createAddress = (apartmentId, lattitude, longitude) => {
        let postAddressData = {
            associateId: apartmentId, defaultAddress: "No",
            fullAddress: this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city, geolocationLat: lattitude, geolocationLng: longitude, label: "Billing Address"
        };
        fetch(process.env.REACT_APP_NODE_ENV + '/api/address/createAddress', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              },
            body: JSON.stringify(postAddressData)
        }).then((response) => response.json())
            .then(data => {
                this.nextPath("/aprt-customer/customer-details", this.state.customerId)
            })
    }

    handleFormFields = (event) => {
        this.validator.showMessageFor(event.target.name)
        switch (event.target.id) {
			case "ufirstName":
				this.setState({ userFirstName: event.target.value });
				break;
			case "ulastName":
				this.setState({ userLastName: event.target.value });
				break;
            case "uapartmentName":
                this.setState({ "apartmentName": event.target.value });
                break;
            case "uassociationName":
                this.setState({ "associationName": event.target.value });
                break;
            case "udoorNumber":
                this.setState({ "doorNumber": event.target.value });
                break;
            case "ustreetName":
                this.setState({ "streetName": event.target.value });
                break;
            case "uarea":
                this.setState({ "area": event.target.value });
                break;
            case "ucity":
                this.setState({ "city": event.target.value });
                break;
            case "ulandmark":
                this.setState({ "landmark": event.target.value });
                break;
            case "upincode":
                this.setState({ "pincode": event.target.value });
                break;
            case "uapartmentType":
                this.setState({ "apartmentType": event.target.value });
                break;
            case "uroadSize":
                this.setState({ "roadSize": event.target.value });
                break;
            case "uapartmentPhoneNumber":
                this.setState({ "apartmentPhoneNumber": event.target.value });
				this.apartmentcontactnumbervalid(event.target.value)
                break;
            case "udistanceBetweenGateAndSump":
                this.setState({ "distanceBetweenGateAndSump": event.target.value });
                break;
            case "unumberOfTowers":
                this.setState({ "numberOfTowers": event.target.value });
                break;
            case "unumberOfHomes":
                this.setState({ "numberOfHomes": event.target.value });
                break;
            case "utankCapacity":
                this.setState({ "tankCapacity": event.target.value });
                break;
            case "udailyNeed":
                this.setState({ "dailyNeed": event.target.value });
                break;
            case "utotalDissolvedSolids":
                this.setState({ "totalDissolvedSolids": event.target.value });
                break;
            case "uvipCustomer":
                this.setState({ "vipCustomer": event.target.value });
                break;
            case "upocName1":
                this.setState({ "pocName1": event.target.value });
                break;
            case "upocContactnumber1":
                this.setState({ "pocContactNumber1": event.target.value });
				this.contactnumber1(event.target.value)
                break;
            case "upocName2":
                this.setState({ "pocName2": event.target.value });
                break;
            case "upocContactnumber2":
                this.setState({ "pocContactNumber2": event.target.value });
				this.contactnumber2(event.target.value)
                break;
            default:
                break;
        }

    }
	apartmentcontactnumbervalid= (data) => {
		  const postCustData = {  "contactnumber" : data }
		if(data != "") {
		  if(data.length === 10) {  
		  
		  fetch(process.env.REACT_APP_NODE_ENV + '/api/apartmentcustomer/apartmentcontactnumber', {
			  method: 'POST',
			  headers: {
				'Content-Type': 'application/json',
				'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			  },
			  body: JSON.stringify(postCustData)
			}).then((res) => res.json())
			  .then((data) => {
				 
				//console.log(data.error_token)
				if(data.error_token === 1) {
					this.setState({ apartmentPhoneNumberRequired: '1'})
				}
				else {
						this.setState({ apartmentPhoneNumberRequired: data.error_token })
				}
			   
			  })
			  .catch((err) => console.log(err))
		  }
		  else if(data.length <= 9) {
				this.setState({ apartmentPhoneNumberRequired: 0 })
			}
			else if(data.length >= 11) {
				this.setState({ apartmentPhoneNumberRequired: 0 })
			}
	  }
	  else {
				this.setState({ apartmentPhoneNumberRequired: 0 })
		}
		  
		  
	  }
	  
	  contactnumber1 = (data) => {
	   const postCustData = {  "contactnumber" : data }
		if(data != "" && this.state.userPhoneNumber != data) {
			  if(data.length === 10) {
				  fetch(process.env.REACT_APP_NODE_ENV + '/api/apartmentcustomer/contactnumber1', {
					  method: 'POST',
					  headers: {
						'Content-Type': 'application/json',
						'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
					  },
					  body: JSON.stringify(postCustData)
					}).then((res) => res.json())
					  .then((data) => {
						 
						console.log(data.error_token)
						if(data.error_token === 1) {
							this.setState({ apartmentcontact1Required: '1'})
						}
						else {
								this.setState({ apartmentcontact1Required: data.error_token })
						}
					   
					  })
					  .catch((err) => console.log(err))
						  
				}
				else if(data.length <= 9) {
					this.setState({ apartmentcontact1Required: 0 })
				}
				else if(data.length >= 11) {
					this.setState({ apartmentcontact1Required: 0 })
				}
		}
	}
	
 contactnumber2 = (data) => {
	   const postCustData = {  "contactnumber" : data }
		if(data != "" ) {
			console.log(this.state.contact2, data)
			if(this.state.contact2 === data) {
				this.setState({ apartmentcontact2Required: 0})
			}
			  else {
			  if(data.length === 10) {
				  fetch(process.env.REACT_APP_NODE_ENV + '/api/apartmentcustomer/contactnumber2', {
					  method: 'POST',
					  headers: {
						'Content-Type': 'application/json',
						'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
					  },
					  body: JSON.stringify(postCustData)
					}).then((res) => res.json())
					  .then((data) => {
						 
						console.log(data.error_token)
						if(data.error_token === 1) {
							this.setState({ apartmentcontact2Required: '1'})
						}
						else {
								this.setState({ apartmentcontact2Required: data.error_token })
						}
					   
					  })
					  .catch((err) => console.log(err))
						  
				}
				else if(data.length <= 9) {
					this.setState({ apartmentcontact2Required: 0 })
				}
				else if(data.length >= 11) {
					this.setState({ apartmentcontact2Required: 0 })
				}
			  }
		}
	}
    validForm() {
        const { userFirstName, userLastName,apartmentName, associationName, doorNumber, streetName, area,
            city, landmark, pincode, apartmentType, roadSize, apartmentPhoneNumber,
            distanceBetweenGateAndSump, numberOfTowers, numberOfHomes, tankCapacity, dailyNeed, totalDissolvedSolids,
            pocName1, pocContactNumber1, pocName2, pocContactNumber2 } = this.state;
        let validFormFlag = false;
        if (apartmentName === '') {
            this.setState({ apartmentName: true });
            return validFormFlag;
        }
		if (userFirstName === '') {
            this.setState({ userFirstName: true });
            return validFormFlag;
        }
		if (userLastName === '') {
            this.setState({ userLastName: true });
            return validFormFlag;
        }
        else if (associationName === '') {
            this.setState({ associationName: true });
            return validFormFlag;
        }

        else if (doorNumber === '') {
            this.setState({ doorNumber: true });
            return validFormFlag;
        }
        // else if (streetName === '') {
        //     this.setState({ streetName: true });
        //     return validFormFlag;
        // }
        else if (area === '') {
            this.setState({ area: true });
            return validFormFlag;
        }
        else if (city === '') {
            this.setState({ city: true });
            return validFormFlag;
        }
        else if (landmark === '') {
            this.setState({ landmark: true });
            return validFormFlag;
        }
        else if (pincode === '') {
            this.setState({ pincode: true });
            return validFormFlag;
        }

        else if (apartmentType === '') {
            this.setState({ apartmentType: true });
            return validFormFlag;
        }
        else if (roadSize === '') {
            this.setState({ roadSize: true });
            return validFormFlag;
        }

        else if (apartmentPhoneNumber === '') {
            this.setState({ apartmentPhoneNumber: true });
            return validFormFlag;
        }
        else if (distanceBetweenGateAndSump === '') {
            this.setState({ distanceBetweenGateAndSump: true });
            return validFormFlag;
        }
        else if (numberOfTowers === '') {
            this.setState({ numberOfTowers: true });
            return validFormFlag;
        }
        else if (numberOfHomes === '') {
            this.setState({ numberOfHomes: true });
            return validFormFlag;
        }
        else if (tankCapacity === '') {
            this.setState({ tankCapacity: true });
            return validFormFlag;
        }
        else if (dailyNeed === '') {
            this.setState({ dailyNeed: true });
            return validFormFlag;
        }
        else if (totalDissolvedSolids === '') {
            this.setState({ totalDissolvedSolids: true });
            return validFormFlag;
        }
        else if (pocName1 === '') {
            this.setState({ pocName1: true });
            return validFormFlag;
        }
        else if (pocContactNumber1 === '') {
            this.setState({ pocContactNumber1: true });
            return validFormFlag;
        }
        else if (pocName2 === '') {
            this.setState({ pocName2: true });
            return validFormFlag;
        }
        else if (pocContactNumber2 === '') {
            this.setState({ pocContactNumber2: true });
            return validFormFlag;
        }

        else {
            return true;
        }
    }

    navigate = () => {
        if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User") {
            this.nextPath("/aprt-customer/customer-details", this.state.customerId)
        } else {
            this.nextPath("/")
        }
    }

    render() {

        let breadCrumbForUser = ""
        let vipCustomer = ""
        if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User") {
            breadCrumbForUser = (<Breadcrumb>
                <Breadcrumb.Item
                    onClick={() => this.nextPath("/aprt-customer/customer-list")}
                >
                    Customer List
      </Breadcrumb.Item>

                <Breadcrumb.Item active>Customer Details</Breadcrumb.Item>
            </Breadcrumb>)
            // vipCustomer = (
            //     <Form.Group className="col-lg-4" as={Col} controlId="uvipCustomer">
            //         <Form.Label>VIP Customer:</Form.Label>
            //         <Form.Control as="select" value={this.state.vipCustomer}
            //             onChange={this.handleFormFields}
            //             name="vipCustomer">
            //             <option value="">--VIP Customer--</option>
            //             <option value="YES"> Yes </option>
            //             <option value="NO"> No </option>
            //         </Form.Control>
            //     </Form.Group>
            //     )
        } else {
            breadCrumbForUser = (<Breadcrumb>
                <Breadcrumb.Item active>Customer Details</Breadcrumb.Item>
            </Breadcrumb>)
        }

        return (<>
            {breadCrumbForUser}

            <div>
                <Card>
                    <Card.Body>
                        <Card.Title style={{ fontWeight: "bold", fontSize: "20px" }}>
                          <div className ="row">
								<div className="col-lg-8">
									 Customer Details - {this.state.apartmentName} <br />
								</div>
								<div className="col-lg-4">
									<Button className="float-right"
												variant="outline-danger"
												style={{ marginLeft: "10px", marginTop: "25px", width: "120px" }}
												onClick={this.navigate}>
												Cancel
								  </Button>&nbsp;&nbsp;&nbsp;
											<Button className="float-right"
												variant="outline-success"
												style={{ marginTop: "25px", width: "120px" }}
												onClick={this.save}>
												Save
								  </Button>
								
								</div>
								
							</div>
                        </Card.Title>
                        <br />
                        <br />
                        <Tabs defaultActiveKey="basic-details">
                            <Tab eventKey="basic-details" title="Billing Address">
                                <Form>
								<div className="kt-heading kt-heading--md">Basic Details</div>
                                    <Form.Row>
                                        <Form.Group controlId="ufirstName" as={Col} className="col-lg-4">
                                            <Form.Label> First Name: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="FirstName"

                                                value={this.state.userFirstName}
                                                onChange={this.handleFormFields}
                                            >
                                            </Form.Control>
                                            {
											  this.validator.message('FirstName', this.state.userFirstName, 'required|alpha_space')
											}
											
                                        </Form.Group>
										 <Form.Group controlId="ulastName" as={Col} className="col-lg-4">
                                            <Form.Label> Last Name: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="LastName"

                                                value={this.state.userLastName}
                                                onChange={this.handleFormFields}
                                            >
                                            </Form.Control>
                                            {
											  this.validator.message('LastName', this.state.userLastName, 'required|alpha_space')
											}
											
                                        </Form.Group>
										
									</Form.Row>
								
								
								
									<div className="kt-heading kt-heading--md">Billing Address </div>
                                    <Form.Row>
                                        <Form.Group controlId="uapartmentName" as={Col} className="col-lg-4">
                                            <Form.Label> Apartment Name: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="apartmentName"

                                                value={this.state.apartmentName}
                                                onChange={this.handleFormFields}
                                            >
                                            </Form.Control>
                                            {
                                                this.validator.message('apartmentName', this.state.apartmentName,
                                                    'required|max:150')
                                            }
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="uassociationName" className="col-lg-4">
                                            <Form.Label> Association Name: </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.associationName}

                                                name="associationName"
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            
                                        </Form.Group>
										 <Form.Group as={Col} controlId="uapartmentType" className="col-lg-4">
                                            <Form.Label> Apartment Type: *</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={this.state.apartmentType} disabled
                                                onChange={this.handleFormFields}
                                                name="apartmentType"
                                            >
                                                <option value="">Select Apartment Size</option>
                                                <option value="Large(500 - 1000)">Large(500 - 1000)</option>
                                                <option value="Medium(300 - 500)">Medium(300 - 500)</option>
                                                <option value="Small(Less than 300)">Small(Less than 300)</option>

                                            </Form.Control>
                                            {
                                                this.validator.message('apartmentType', this.state.apartmentType,
                                                    'required|string')
                                            }
                                        </Form.Group>
                                    </Form.Row>
									
                                    <Form.Row>
									 <Form.Group as={Col} controlId="uapartmentPhoneNumber" className="col-lg-4">
                                            <Form.Label> Apartment Mobile Number: </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="apartmentPhoneNumber"
                                                id="uapartmentPhoneNumber"
                                                value={this.state.apartmentPhoneNumber}
                                                onChange={this.handleFormFields}

                                            ></Form.Control>
                                           
											
											
											  {(this.state.apartmentPhoneNumberRequired != 0 ?
						  <div class="text-danger">Apartment Mobile Number Already exists.</div> :  this.validator.message('Apartment Phone No', this.state.apartmentPhoneNumber, 'phone|max:10') ) }
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="udoorNumber" className="col-lg-4">
                                            <Form.Label> Door Number: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.doorNumber}
                                                onChange={this.handleFormFields}
                                                name="doorNumber"
                                            ></Form.Control>
                                            {
                                                this.validator.message('doorNumber', this.state.doorNumber,
                                                    'required')
                                            }
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="ustreetName" className="col-lg-4">
                                            <Form.Label> Street Name: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.streetName}
                                                onChange={this.handleFormFields}
                                                name="streetName"
                                            ></Form.Control>
                                            {
                                                this.validator.message('streetName', this.state.streetName,
                                                    'required')
                                            }
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="uarea" className="col-lg-4">
                                            <Form.Label> Area: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.area}
                                                name="area"
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('area', this.state.area, 'required|regex:^[a-zA-Z-. ]*$')
                                            }
                                        </Form.Group>
										 <Form.Group as={Col} controlId="ucity">
                                            <Form.Label> City: *</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={this.state.city} disabled
                                                onChange={this.handleFormFields}
                                                name="city"
                                            >
                                                <option value="">Select Your City</option>
                                                <option value="Chennai">Chennai</option>
                                            </Form.Control>
                                            {
                                                this.validator.message('city', this.state.city,
                                                    'required|alpha_space')
                                            }
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="ulandmark">
                                            <Form.Label> Landmark: </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.landmark}
                                                onChange={this.handleFormFields}
                                                name="landmark"
                                            ></Form.Control>
                                            {
                                                this.validator.message('landmark', this.state.landmark,
                                                    'alpha_space')
                                            }
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                       
                                        <Form.Group as={Col} controlId="upincode" className="col-lg-4">
                                            <Form.Label> Pincode: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.pincode}
                                                name="pincode"
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('pincode', this.state.pincode,
                                                    'required|integer|max:6|min:6')
                                            }
                                        </Form.Group>
										 <div className="col-lg-4">
										  
											<label>Profile Picture</label>
											<input type="file" className="form-control"  placeholder="Upload your file"  
											
											    onChange={(e)=> { this.handleChange(e)  }}  onClick={(e)=> { e.target.value = null}}
											
											 / >
											 
										
										</div>
										<div className="col-log-2" style={{ margin:"20px 0px" }}>
											<img src={this.state.profileimageurl} width="80px" height = "40px" />
										</div>
										
                                    </Form.Row>
									<Form.Row>
										<div className="col-lg-4" >
											<label>Contract Document</label>
											<input type="file" className="form-control"  placeholder="Upload your file"  
											
											    onChange={(e)=> { this.documenturlChange(e)  }}  onClick={(e)=> { e.target.value = null}}
											
											 / >
										</div>
										<div className="col-log-2" style={{ margin:"22px 0px" }}>
											<div className="form-control">
												<a href={this.state.contactdocumenturl} download>View document</a>
											</div>
										</div>
									</Form.Row>
                                </Form>
                            </Tab>

                            <Tab eventKey="apartmentDetails" title="Apartment Details">
                                <Form>
								  <div className="kt-heading kt-heading--md">Apartment Details</div>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="uroadSize" className="col-lg-4">
                                            <Form.Label>Road Size (in ft)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.roadSize}
                                                onChange={this.handleFormFields}
                                                name="roadSize"
                                            ></Form.Control>
                                            {
                                                this.validator.message('roadSize', this.state.roadSize,
                                                    'integer,num')
                                            }
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="udistanceBetweenGateAndSump">
                                            <Form.Label>Distance Between Gate & Sump (in ft): </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="distanceBetweenGateAndSump"
                                                id="udistanceBetweenGateAndSump"
                                                value={this.state.distanceBetweenGateAndSump}
                                                onChange={this.handleFormFields}

                                            ></Form.Control>
                                            {
                                                this.validator.message('distanceBetweenGateAndSump', this.state.distanceBetweenGateAndSump,
                                                    'integer')
                                            }
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="unumberOfTowers">
                                            <Form.Label> Number of Towers: </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.numberOfTowers}
                                                onChange={this.handleFormFields}
                                                name="numberOfTowers"
                                            ></Form.Control>
                                            {
                                                this.validator.message('numberOfTowers', this.state.numberOfTowers, 'integer|max:1000,num')
                                            }
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="unumberOfHomes">
                                            <Form.Label> Number of Homes: </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.numberOfHomes}
                                                onChange={this.handleFormFields}
                                                name="numberOfHomes"
                                            ></Form.Control>
                                            {
                                                this.validator.message('numberOfHomes', this.state.numberOfHomes,
                                                    'integer')
                                            }
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="utankCapacity">
                                            <Form.Label> Sump/Tank Capacity (in kl): *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.tankCapacity}
                                                onChange={this.handleFormFields}
                                                name="tankCapacity"
                                            ></Form.Control>
                                            {
                                                this.validator.message('tankCapacity', this.state.tankCapacity,
                                                    'required|currency')
                                            }

                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col} controlId="udailyNeed">
                                            <Form.Label> Daily Need(in kl): *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.dailyNeed}
                                                onChange={this.handleFormFields}
                                                name="dailyNeed"
                                            ></Form.Control>
                                            {
                                                this.validator.message('dailyNeed', this.state.dailyNeed,
                                                    'required|currency')
                                            }
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group className="col-lg-4" as={Col} controlId="utotalDissolvedSolids">
                                            <Form.Label>Preferred TDS: *</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={this.state.totalDissolvedSolids}
                                                onChange={this.handleFormFields}
                                                name="totalDissolvedSolids"
                                            >
                                                <option value="">Select TDS</option>
                                                <option value="less than 300(Excellent)"> less than 300(Excellent) </option>
                                                <option value="300-500(Good)"> 300-500(Good) </option>
                                                <option value="600-900(Fair)"> 600-900(Fair) </option>
                                                <option value="900-1200(Poor)"> 900-1200(Poor)</option>
                                                <option value="Above 1200(Unacceptable)"> Above 1200(Unacceptable)   </option>
                                            </Form.Control>
                                            {
                                                this.validator.message('Preferred tds', this.state.totalDissolvedSolids,
                                                    'required|string')
                                            }
                                        </Form.Group>
                                    </Form.Row>
                                </Form>
                            </Tab>

                            <Tab eventKey="poc" title="Contact Details">
                                <Form>
								  <div className="kt-heading kt-heading--md">Contact Details</div>
                                    <Form.Row>
                                        <Form.Group className="col-lg-4" as={Col} controlId="upocName1">
                                            <Form.Label> Contact Person 1: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.pocName1}
                                                onChange={this.handleFormFields}
                                                name="Name1"
                                            ></Form.Control>
                                            {
                                                this.validator.message('Contact Person 1', this.state.pocName1, 'required|alpha_space')
                                            }
                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col} controlId="upocContactnumber1">
                                            <Form.Label> Contact Number 1: *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.pocContactNumber1}
                                                onChange={this.handleFormFields}
                                                name="Contact Number 1"
                                            ></Form.Control>
                                           
											 {(this.state.apartmentcontact1Required != 0 ?
						  <div class="text-danger">Contact Number 1  Already exists.</div> : this.validator.message('Contact Number 1', this.state.pocContactNumber1, 'required|phone|max:10') ) }
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group className="col-lg-4" as={Col} controlId="upocName2">
                                            <Form.Label> Contact Person 2:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.pocName2}
                                                onChange={this.handleFormFields}
                                                name="Name2"
                                            ></Form.Control>
                                            
                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col} controlId="upocContactnumber2">
                                            <Form.Label>Contact Number 2:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.pocContactNumber2}
                                                onChange={this.handleFormFields}
                                                name="Contact Number 2"
                                            ></Form.Control>
											 {(this.state.apartmentcontact2Required != 0 ?
						  <div class="text-danger">Contact Number 2  Already exists.</div> : this.validator.message('Contact Number 2', this.state.pocContactNumber1, 'phone|max:10') ) } 
                                            
                                        </Form.Group>
                                    </Form.Row>
                                </Form>
                            </Tab>
                        </Tabs>
                    </Card.Body>
                </Card>
            </div>
        </>
        );
    }
}

const mapStateToProps = (state /*, ownProps*/) => {
    return {
        userRole: state.auth.user[0].userType,
        userId: state.auth.user[0].id,
		mobiledevice: state.auth.user[0].mobiledeviceId,
    }
}

export default connect(
    mapStateToProps,
    null
)(EditCustomerDetails)